module.exports = __webpack_public_path__ + "img/403_forbidden.2a055698.png";